<template>
  <div class="QrCodeDiv" v-show="isShowQr">
    <div class="QrCodeData">
      <em class="el-icon-close detIcon" @click="isShowOpen()"></em>
      <div class="qrcodeBorder">
        <div id="qrcode" ref="qrCodeUrl"></div>
      </div>
      <p class="describe">扫描二维码上传图片</p>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { getStore } from "@/utils/localStorage";

export default {
  name: "QrCode",
  data() {
    return {
      isShowQr: false,
      topIdText: "",
      changeData: "",
      qRCodeData: "",
      mobileData: "",
      studentId: '', 
    };
  },
  mounted() {
    this.mobileData = JSON.parse(getStore("userInfo")).mobile;
    this.studentId = JSON.parse(getStore("userInfo")).student_id;
  },
  methods: {
    creatQrCode() {
      // 先清空
      this.qRCodeData = null;
      this.$refs.qrCodeUrl.innerHTML = "";

      const url = window.location.origin;
      const getData = getStore("token");
      const _ENTRANCETYPE = this.$store.state.permission._ENTRANCETYPE;
      const time = new Date().getTime();
      this.$store.commit('common/getTimeMutation', time)
      let tag = _ENTRANCETYPE + this.studentId + this.mobileData + time;
      const text = `${url}/#/uploadImg?token=${getData}&_ENTRANCETYPE=${_ENTRANCETYPE}&tag=${tag}`;
      console.log(text);
      this.qRCodeData = new QRCode(this.$refs.qrCodeUrl, {
        text: text,
        width: 180,
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    async isShowOpen() {
      this.isShowQr = !this.isShowQr;
      const codeHtml = document.getElementById("qrcode");
      codeHtml.innerHTML = "";
      if (this.isShowQr) {
        this.creatQrCode();
        this.$emit("getUpdateImg", this.mobileData);
      } else {
        this.$emit("closeQr");
      }
    },
    isHideOpen() {
      this.isShowQr = false;
      this.$emit("closeQr");
    },
  },
};
</script>

<style scoped lang="scss">
.QrCodeDiv {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.QrCodeData {
  width: 300px;
  height: 300px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.qrcodeBorder {
  width: 200px;
  height: 200px;
  border: 1px solid #e8e8e8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
}
.detIcon {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 30px;
  cursor: pointer;
}
.describe {
  color: #333;
  font-size: 14px;
  margin-top: 30px;
}
</style>
